import { Text, View } from '@react-pdf/renderer'
import PDFCell from '@/components/ReportPDF/PDFCell'
import PDFPage from '@/components/ReportPDF/PDFPage'
import PDFParagraph from '@/components/ReportPDF/PDFParagraph'
import PDFRow from '@/components/ReportPDF/PDFRow'
import PDFTitle from '@/components/ReportPDF/PDFTitle'
import styles from '@/components/ReportPDF/styles'

const TableRow = ({ index, subject, sender, senderMail, color }) => (
  <PDFRow width={1075} marginLeft={-85}>
    <PDFCell flex={2}>
      <Text style={color}>{index}</Text>
    </PDFCell>
    {/* <PDFCell flex={2}>
      <Text style={color}>{temp}</Text>
    </PDFCell> */}
    <PDFCell flex={5}>
      <Text style={color}>{subject}</Text>
    </PDFCell>
    <PDFCell flex={3}>
      <Text style={color}>{sender}</Text>
    </PDFCell>
    <PDFCell flex={5}>
      <Text style={color}>{senderMail}</Text>
    </PDFCell>
  </PDFRow>
)

const Chapter3Sub2Page = ({ reportData, setPage }) => {
  const { emailTempLogReports, phishType, secondaryCompanyNickname } = reportData || {}
  const service = phishType

  return (
    <PDFPage hideTitleDivider reportData={reportData}>
      <PDFTitle hideDivider>3.5 執行內容</PDFTitle>

      <Text
        render={({ pageNumber }) => {
          setPage({ chap3_5: pageNumber })
        }}
      />

      <View style={styles.section}>
        <PDFParagraph>
          {'    '}
          依社交工程測試專案要求，<Text>{service}</Text>
          內容設計可涵蓋不同類型，以供受測單位進行測試，且每封樣本經雙方協議之模式加以評定樣本之有效性與強度。測試信件將夾帶特製之識別因子，於信件開啟、點閱連結及下載附件時，會啟動回報機制，
          <Text>{secondaryCompanyNickname}</Text>
          僅進行資料統計，於測試期間並無任何入侵行為。
        </PDFParagraph>
        <PDFParagraph>
          {'    '}
          <Text>{secondaryCompanyNickname}</Text>
          將於測試前與承辦單位充分溝通及確認測試細節，於約定之測試時程，
          <Text>{secondaryCompanyNickname}</Text>
          將採用無預警方式寄發測試<Text>{service}</Text>
          進行演練，以防受測單位採取預警措施，將影響統計結果。此外寄發測試<Text>{service}</Text>
          時間應選擇組織成員一般工作時間，避免如員工旅遊、單位受訓等情況下進行測試，以求測試統計結果的完整性與客觀程度。
        </PDFParagraph>
        <PDFParagraph>
          {'    '}
          <Text>{secondaryCompanyNickname}</Text>
          將提供不同行為模式之分析報告，報告之格式可依單位之需要，經協議後進行客製化作業。
        </PDFParagraph>
      </View>
      <PDFTitle hideDivider>3.6 檢測信件範本</PDFTitle>

      <Text
        render={({ pageNumber }) => {
          setPage({ chap3_6: pageNumber })
        }}
      />

      <View>
        <PDFParagraph>
          {'    '}
          <Text style={{ marginBottom: 20 }}>
            依社交工程測試專案要求，
            <Text>{service}</Text>
            內容設計可涵蓋不同類型，以供受測單位進行測試。本次檢測範本如下列所示：
          </Text>
        </PDFParagraph>

        <TableRow index="樣板編號" subject="信件標題" sender="寄件者" senderMail="寄件者信箱" />

        {emailTempLogReports?.map(({ tempSubject, sendName, sendSource }, index) => (
          <TableRow
            key={`${index + 1}`}
            index={`${index + 1}`}
            subject={tempSubject}
            sender={sendName}
            senderMail={sendSource}
          />
        ))}
      </View>
    </PDFPage>
  )
}

export default Chapter3Sub2Page
